import { useCallback, useState } from "react";
import { Fornecedores } from "../../types";
import { FornecedoresService } from "./fornecedores.service";
import { useStores } from "../../components/contexts/store-provider.context";

export function useFornecedores() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Fornecedores>();
  const [dataArray, setDataArray] = useState<Fornecedores[]>();
  const { fornecedoresStore } = useStores();

  const getFornecedor = useCallback(async (id: string) => {
    fornecedoresStore.setCrudLoading("edit", true);
    const res = await FornecedoresService.getFornecedor(id);
    if (res) {
      fornecedoresStore.setSelectedData(res);
    }
    fornecedoresStore.setCrudLoading("edit", false);
  }, []);

  const getFornecedores = useCallback(async () => {
    if (!fornecedoresStore.data) {
      fornecedoresStore.setLoading(true);
    }

    const res = await FornecedoresService.getFornecedores();
    if (res) {
      fornecedoresStore.set(res);
    }
    fornecedoresStore.setLoading(false);
  }, []);

  const deleteFornecedor = useCallback(async (data: Fornecedores) => {
    await FornecedoresService.deleteFornecedor(data);
    fornecedoresStore.removeItem((item) => item.id === data.id);
  }, []);

  const addFornecedor = useCallback(async (data: Fornecedores) => {
    await FornecedoresService.addFornecedor(data);
    fornecedoresStore.add(data);
  }, []);

  const updateFornecedor = useCallback(async (data: Fornecedores) => {
    await FornecedoresService.updateFornecedor(data);
    fornecedoresStore.update(data.id || "-1", data);
  }, []);

  return {
    getFornecedor,
    getFornecedores,
    deleteFornecedor,
    addFornecedor,
    updateFornecedor,
    loading,
    data,
    dataArray,
  };
}
